import "./DashboardPortfolioSummaryComponentSmall.scss";
import {IComponentOptions, IRootElementService, IScope} from "angular";
import {DashboardPortfolioSummaryComponentController} from "../DashboardPortfolioSummaryComponentController";
import {MarginQuizService} from "../../../../../quiz/margin/service/MarginQuizService";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";
import {AccountStore} from "../../../../../account/store/AccountStore";
import {PortfolioService} from "../../../../../portfolio/service/PortfolioService";

export const PortfolioSummarySmall = "tfDashboardPortfolioSummarySmall";

export function portfolioSummarySmall(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/portfolio-summary/small/DashboardPortfolioSummaryComponentSmall.html`,
        bindings: {
            model: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardPortfolioSummaryComponentSmallController
    };
}

export class DashboardPortfolioSummaryComponentSmallController extends DashboardPortfolioSummaryComponentController {

    /** @ngInject */
    public constructor($scope: IScope,
                       $element: IRootElementService,
                       accountStore: AccountStore,
                       portfolioService: PortfolioService,
                       marginQuizService: MarginQuizService,
                       currentUserService: CurrentUserService) {
        super($scope, $element, accountStore, portfolioService, marginQuizService, currentUserService);
    }
}
